import React, { useState, useEffect } from 'react';
import {
  Label,
} from 'reactstrap';
import _ from 'lodash';
import Services from '../services';
import moment from 'moment';
import { DatetimePicker } from '../../../commons/controls';
import RFForm from '../../../components/Form/RFForm';
import SelectField from '../../../components/Form/SelectField';
import TimeFormatter from '../../../commons/TimeFormatter';

const COL_STYLE = {marginBottom: '15px'};
const ROW_STYLE = {marginLeft: '15px', marginRight: '15px'};
const KartyaGeneralasFilter = props => {
  const {
    setFilter
  } = props;

  let selected = false; 

  const [type, setType] = useState(null);
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  useEffect(() => {
    setStart(new Date(new Date().setMonth(new Date().getMonth()-1)));
  }, []);

  useEffect(() => {
      setFilter(
        {
          kartyaTipusId: type && type.id,
          kezdete: start ? TimeFormatter.formatIso(start) : null,
          vege: end ? TimeFormatter.formatIso(end) : null,
        }
      );
  }, [type, start, end]);

  const styles = {
    control: base => ({
      ...base,
      '&:focus': { borderColor: 'red' }, // border style on hover
      border: '1px solid lightgray', // default border color
      boxShadow: 'none', // no box-shadow
      borderRadius: '0'
    }),
  };

  const loadKartyaTipusOptions = (input, callback) => {
    Services.listKartyaTipus(false, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!input && !type && options.length === 1) {
          setType(options[0]);
        }
      }
    });
  }

  const handleDateChange = (e,v,type) => {
    if(selected) {
      selected = false;
      
      switch (type) {
        case 'FORMERVKEZD':
          setStart(moment(e).startOf('day'))
          break;
        case 'FORMERVVEGE':
          setEnd(moment(e).endOf('day'))
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMERVKEZD':
          setStart(v === '' ? null : e)
          break;
        case 'FORMERVVEGE':
          setEnd(v === '' ? null : e)
          break;
        default:
          break;
      }
    }
  }

  return(
    <React.Fragment>
      <RFForm onSubmit={() => {}}>
        <div className="row" >
          <div className="col-md-2">
            <h5>Szűrési feltételek: </h5>
          </div>
        </div>
        <div className="row" style={ROW_STYLE}>
          <div className="col-md-2" style={COL_STYLE}>
            <SelectField
              variant='async'
              label='Kártyatípus:'
              styles={styles}
              name="type"
              id="type"
              placeholder="Kártyatípus..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => setType(v)}
              loadOptions={_.debounce(loadKartyaTipusOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={type}
              defaultOptions
              isClearable
            />
          </div>
          <div className="col-md-2" style={COL_STYLE}>
            <DatetimePicker
                label={'Érvényesség kezdete:'}
                id={"start"}
                name={"start"}
                value={start && new Date(start)}
                //onChange={(e,v) => setStart(v === '' ? null : v)} 
                onChange={(e,v) => {handleDateChange(e,v,'FORMERVKEZD')}}
                onSelect={(e,v) => { selected = true }}
                containerClassName="organw-date-time"
                time={true}
                // format="YYYY-MM-DD HH:mm:ss"
                messages={{ dateButton: "dátum" , timeButton: "idő"}}
                timePrecision="seconds"
                required
              />
          </div>
            <div className="col-md-2" style={COL_STYLE}>
              <DatetimePicker
                label={'Érvényesség vége:'}
                id={"end"}
                name={"end"}
                value={end && new Date(end)}
                //onChange={(e,v) => setEnd(v === '' ? null : v)}
                onChange={(e,v) => {handleDateChange(e,v,'FORMERVVEGE')}}
                onSelect={(e,v) => { selected = true }}
                containerClassName="organw-date-time"
                time={true}
                // format="YYYY-MM-DD HH:mm:ss"
                messages={{ dateButton: "dátum" , timeButton: "idő"}}
                timePrecision="seconds"
                required
              />
            </div>
          </div>
        </RFForm>
      </React.Fragment>
  );
}

export default KartyaGeneralasFilter;